import {
    OperatorAccess,
    PERMISSIONS,
    PermissionCode,
    can,
} from '../../../lib/permissions';

// Permiso v8 que exige cada acción que el backend ofrece para una pieza del
// cuadrante (`privilegesData.actions`).
const ACTION_PERMISSIONS: Record<string, PermissionCode> = {
    book: PERMISSIONS.BOOKING.CREATE,
    createFixedBooking: PERMISSIONS.FIXED_BOOKING.CREATE,
    createClass: PERMISSIONS.ACTIVITY.CREATE,
    closeFacilities: PERMISSIONS.CLOSURE.CREATE,
};

/**
 * Las acciones del backend para la pieza que además permite el rol del
 * operador. Nunca añade acciones: solo quita las que el operador no puede
 * hacer. Con los roles apagados devuelve la lista del backend tal cual.
 */
export function filterTimetableActions(
    actions: readonly string[] | undefined | null,
    access: OperatorAccess,
): string[] {
    return (actions ?? []).filter((action) => {
        const required = ACTION_PERMISSIONS[action];
        return !required || can(access, required);
    });
}

/** Pegar una reserva cortada la mueve: exige `booking.modify`. */
export function canPasteBooking(access: OperatorAccess): boolean {
    return can(access, PERMISSIONS.BOOKING.MODIFY);
}
